import { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  ClientOrderProductItemModel,
  ClientOrdersStatisticsModel,
} from '../../models/ClientOrders';
import { StatisticsFilterModel } from '../../models/StatisticsFilterModel';

interface IClientOrdersService {
  getOrders: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ClientOrderProductItemModel[]>>;
  getOrdersStatistics: (
    data: StatisticsFilterModel,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ClientOrdersStatisticsModel>>;
}

export const clientOrdersService: IClientOrdersService = {
  getOrders(queryString, axiosConfig) {
    return ajax.get<ClientOrderProductItemModel[]>(
      `${config.benefitApiUrl}/odata/client-orders?${queryString}`,
      axiosConfig,
    );
  },
  getOrdersStatistics(data, axiosConfig) {
    return ajax.get<ClientOrdersStatisticsModel>(
      `${config.benefitApiUrl}/client-orders/statistics`,
      {
        ...axiosConfig,
        params: {
          dateStart: data.dateStart
            ? moment(data.dateStart).format('YYYY-MM-DD')
            : undefined,
          dateEnd: data.dateEnd
            ? moment(data.dateEnd).format('YYYY-MM-DD')
            : undefined,
          companyId: data.companyId,
        },
      },
    );
  },
};
